import { FC, useContext } from 'react';
import { Menu, Spinner } from '@chakra-ui/react';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';
import { useRunTangoRequest } from '~/core/shared/api/plugin';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import { handleSuccess } from '~/core/shared/utils/admin';
import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../Layout.component';

export const TangoXmlMenuItem: FC = () => {
  const { runTangoRequest, isPending } = useRunTangoRequest();
  const { applicationUuid, actionContexts } = useContext(ApplicationContext);

  const {
    action: { text, key },
  } = useContext(DocumentDetailsViewActionContext);

  const parameters: Record<string, string> = actionContexts[key]
    ? actionContexts[key].parameters
    : {};
  const modal: UseOpenCloseReturn = actionContexts[key]
    ? actionContexts[key].modal
    : {};
  const isPreview = parameters.preview === 'yes';

  const { hooks } = useContext(ApplicationContext);

  const exportToTangoHook = hooks.find((h) => h.id === 'exportToTango');
  const isExportToTangoDenied =
    exportToTangoHook?.status === 'deny' && !isPreview;

  const handleRunTangoRequest = useEventHandler(async (): Promise<void> => {
    if (isExportToTangoDenied) return;
    try {
      await runTangoRequest({ params: { id: applicationUuid, ...parameters } });
      if (isPreview) {
        modal.onOpen();
      } else {
        handleSuccess('Information sent to Tango LMS');
      }
    } catch {
      // Error is handled in useRunTangoRequest
    }
  });

  return (
    <Menu.Item
      disabled={isExportToTangoDenied}
      onClick={handleRunTangoRequest}
      value={`tango-xml-${key}`}
    >
      {isPending && <Spinner size="xs" />}
      {text}
    </Menu.Item>
  );
};
